var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "lb-btn-container", attrs: { id: "back-forward-buttons" } },
    [
      _c(
        "div",
        {
          staticClass: "red-pill-button-of-hate go-next extra-left-margin",
          on: {
            click: function($event) {
              return _vm.openProject()
            }
          }
        },
        [_vm._v("Открыть")]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }